module.exports = __webpack_public_path__ + "media/images/gallery/constellations/gc_layer_on-58417177f74b0a022d12537f85aa0a1c.png";